import Header from './californio.header.js';
import Product from './californio.product.js';
import Tag from './californio.tag.js';

const CalifornioNew = {
  //#region ShowBrand
  showBrand: function () {
    /**
     * Função para exibir a marca da Californio no console
     * */

    console.info(
      `%c💻 Califórnio - MKT Digital %c\n🌐 https://www.californio.com.br/`,
      `color: white; background: linear-gradient(90deg, #333, #666); font-size: 16px; font-weight: bold; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; text-shadow: 1px 1px 2px rgba(0,0,0,0.3); padding: 6px 12px; margin: 8px 0px 2px; border-radius: 6px;`,
      `color: gray; font-size: 12px; font-weight: 500; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; padding: 6px 12px; margin: 2px 0px; border-radius: 6px;`
    );
  },

  //--------------------------------------------------------------------------------
  // Função para desabilitar o scroll da página

  disableScroll: () => {
    document.body.style.overflow = 'hidden';
  },

  //--------------------------------------------------------------------------------
  // Função para habilitar o scroll da página
  enableScroll: () => {
    document.body.style.overflow = 'auto';
  },

  //--------------------------------------------------------------------------------
  //#region HandleLoginStyle
  handleLoginStyle: function () {
    /**
     * Função que sobrescreve o estilo do botão de login
     */
    // Seleciona o atributo data-page da tag body
    const page = document.body.getAttribute('data-page');

    if (page !== 'login') return;

    // Seleciona o botão de login
    const login = Array.from(document.querySelectorAll('.cmp-buyer-login-button'));

    // Verifica se o botão de login existe
    if (login.length > 0) {
      // Cria um elemento 'style'
      let style = document.createElement('style');

      // Define o conteúdo do elemento 'style'
      style.innerHTML = `
        .cmp-buyer-login-button{
          background-color: var(--primary-color) !important;
          border-radius: 0 !important;
          font-weight: var(--font-weight-thin) !important;
          height: 4.2rem !important;
          padding: 0.6rem 2rem 0.4rem !important;
          text-transform: capitalize !important;
          
          &:hover{
            background-color: var(--primary-color) !important;
          }

        }
        .cmp-buyer-login-input{
          border: 1px solid var(--primary-color) !important;
          color: var(--primary-color) !important;
          padding: 2rem 0.5rem 1rem !important;
        }
        .cmp-buyer-login-label{
          color: var(--primary-color) !important;
        }
        `;

      // Anexa o elemento 'style' ao 'head' do documento
      document.head.appendChild(style);
    }
  },

  //--------------------------------------------------------------------------------

  //#region HandleLgpdBannerStyle
  handleLgpdBannerStyle: function () {
    /**
     * Função que sobrescreve o estilo do banner de LGPD
     */

    // Cria um elemento 'style'
    let style = document.createElement('style');

    // Define o conteúdo do elemento 'style'
    style.innerHTML = `
        #lgpd-banner{
          font-family: var(--font-family-base) !important;
          border-radius: 0 !important;
        }
        #lgpd-banner .lgpd-banner-action button{
          background-color: var(--primary-color) !important;
          color: var(--white) !important;
          border: 1px solid var(--primary-color) !important;
          border-radius: 0 !important;
          padding: 0.5rem 2rem !important;
          height: 4.2rem !important;
          text-transform: capitalize !important;

          &:hover{
            background-color: var(--primary-color) !important;
            border: 1px solid var(--primary-color) !important;
            color: var(--white) !important;
          }
        }
      `;

    // Anexa o elemento 'style' ao 'head' do documento
    document.head.appendChild(style);
  },

  handlePopupCupom: function () {
    const popup = document.querySelector('.cupom-popup');
    if (!popup) return;

    const btnCopy = popup.querySelector('[data-button-copy]');

    btnCopy.addEventListener('click', function () {
      const cupomText = btnCopy.textContent;

      navigator.clipboard
        .writeText(cupomText)
        .then(() => {
          btnCopy.textContent = 'Copiado!';

          setTimeout(() => {
            popup.classList.remove('-active');
          }, 1500);
        })
        .catch((err) => {
          console.error('Erro ao copiar o cupom:', err);
        });
    });
  },

  //--------------------------------------------------------------------------------
  //#region loadVideos
  loadVideos: function () {
    /**
     * Função para carregar vídeos de acordo com a rolagem da página
     */

    // Seleciona todos os iframes verticais
    const iframes = Array.from(document.querySelectorAll(`.iframe.vertical`));

    // Função para setar o atributo src do iframe
    function setAttributeSrc(iframe) {
      const src = iframe.getAttribute('data-attribute-src');
      if (src) {
        iframe.setAttribute('src', src);
      }
    }

    // Configurações do IntersectionObserver
    const observerOptions = {
      root: null,
      rootMargin: '15px',
      threshold: 0.1, // O vídeo será carregado quando 10% dele estiver visível
    };

    // Cria um novo IntersectionObserver
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setAttributeSrc(entry.target);
          observer.unobserve(entry.target); // Para de observar o elemento após carregar o vídeo
        }
      });
    }, observerOptions);

    // Observa cada iframe
    iframes.forEach((iframe) => {
      observer.observe(iframe);
    });
  },

  //--------------------------------------------------------------------------------
  lockScreen: function () {
    const alert = document.querySelector('#alert');

    // Verifica se o alerta existe e remove a classe 'hidden'
    if (alert) {
      alert.classList.remove('hidden');
      this.disableScroll();
    }
  },

  //--------------------------------------------------------------------------------

  //#region Init
  init: function () {
    /**
     * Função que Inicializa todas as funções da Californio
     */

    const _this = this;

    Header.init();
    Tag.init();
    Product.init();

    _this.showBrand();
    _this.handleLoginStyle();
    _this.handleLgpdBannerStyle();
    _this.handlePopupCupom();
    // _this.lockScreen();
  },
};

export default CalifornioNew;
